/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';

import { useField } from '@unform/core';

import {
  Input as InputComponent,
  InputAdornment,
  InputProps,
  Typography,
} from '@material-ui/core';

import useStyles from './styles';

interface InputLabelProps extends InputProps {
  name: string;
  label?: string;
  icon?: string;
  placeholder?: string;
  defaultValue?: string;
  children?: React.ReactNode;
}

const Input: React.FC<InputLabelProps> = ({
  children,
  label,
  icon,
  name,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, registerField, defaultValue } = useField(name);

  const classes = useStyles();

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <div>
      <Typography className={classes.label}>{icon}</Typography>
      <Typography className={classes.label}>{label}</Typography>
      <InputComponent
        name={name}
        inputRef={inputRef}
        className={classes.input}
        defaultValue={defaultValue}
        inputProps={{ autoCapitalize: 'none' }}
        startAdornment={
          <InputAdornment position="start">{children}</InputAdornment>
        }
        {...rest}
      />
    </div>
  );
};

export default Input;
